<template>
  <div class="public-layout min-height">
    <RouterView></RouterView>
    <FooterComponent></FooterComponent>

    <SiembiotAdComponent></SiembiotAdComponent>

  </div>
</template>
<script>
import '../../assets/publicLayout.css'
import FooterComponent from '@/components/Others/FooterComponent.vue'
import SiembiotAdComponent from '@/components/Modals/SiembiotAdComponent.vue'
export default {
  components: {
    FooterComponent, SiembiotAdComponent
  },
  created() { },
}
</script>

<style scoped>
.public-layout {
  background-color: #eeeeee !important;
  height: 100%;
}

.min-height {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  background-color: #e2f2ff;
}
</style>
